export default __webpack_public_path__ + "static/small3-fc010c724ab089629fa77136ba723926.jpg";